import React , {useState, useImperativeHandle, forwardRef} from 'react'
import {Modal, Button} from 'antd'
import Tools from '../tools/Tools'
import WWTable from "../components/Table"
function BatchCheckModal(props,ref) {
    const [visible,setVisible] = useState(false)
    const [dataSource,setDataSource] = useState([])
    const [successLength,setSuccessLength] = useState(0)

    useImperativeHandle(ref, () => ({
        showModal: (data,successDevices) => {
            setVisible(true)
            let newData = []
            data.map(function (item) {
                item.imeiSet.map(function (imei) {
                    newData.push({
                        imei,
                        errorMessage:item.errorMessage
                    })
                })
            })
            setDataSource(newData)
            setSuccessLength(successDevices.length)
        },
    }));

    function hideModal() {
        setDataSource([])
        setSuccessLength(0)
        setVisible(false)
    }
    
    function submit() {
        let imei = []
        dataSource.forEach(function (item) {
            imei.push(item.imei)
        })
        console.log(imei)
        Tools.copy(imei.join(','))
        props.handleImeiSet && props.handleImeiSet({
            target:{
                value:imei.join('\n')
            }
        })
        setVisible(false)
        if(props.importSubmit) {
            props.importSubmit()
        }
    }

    const columns = [{
        title: Strings.rs10084 || Strings.imei,
        dataIndex: 'imei',
        width: '50%',
        // render: function (text, record, index) {
        //     return <span>{record.imeiSet.join(',')}</span>
        // }
    }, {
        title: Strings.rs14409 || Strings.errorMessage,
        dataIndex: 'errorMessage',
        width: '50%'
    }]

    return <Modal transitionName=""  maskTransitionName=""
                  className="default_modal wid650"
                  destroyOnClose={true}
                  width=""
                  visible={visible}
                  onCancel={hideModal} maskClosable={false}
                  title={Strings.rs14344 || Strings.tips} footer={null}>
            <div className="maps-api-tip column">
                <div>{Strings.rs14410 || Strings.success1}<span className="green">{successLength}</span>&nbsp;&nbsp;
                    {Strings.rs14411 || Strings.fail1}<span className="red">{dataSource.length}</span></div>
                  <div >{Strings.rs14412}</div>
            </div>
        <WWTable  className={"new_app_table"} 
                  hideShadow={true} columns={columns}
                  innerHeight={350} height={0}
                  dataSource={dataSource}  pagination={false} 
                  hiddenPagination={true}/>
        <div className="btn-row mg_top24">
            <Button className="mg_right10" onClick={hideModal}>{Strings.rs10054 || Strings.cancel}</Button>
            <Button type='primary' onClick={submit}>{Strings.rs10058 || Strings.sure}</Button>
        </div>
    </Modal>
}
export default forwardRef(BatchCheckModal)